import { render, staticRenderFns } from "./SelfDeliveryRiderList.vue?vue&type=template&id=5cf509cc&scoped=true"
import script from "./SelfDeliveryRiderList.vue?vue&type=script&lang=js"
export * from "./SelfDeliveryRiderList.vue?vue&type=script&lang=js"
import style0 from "./SelfDeliveryRiderList.vue?vue&type=style&index=0&id=5cf509cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf509cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf509cc')) {
      api.createRecord('5cf509cc', component.options)
    } else {
      api.reload('5cf509cc', component.options)
    }
    module.hot.accept("./SelfDeliveryRiderList.vue?vue&type=template&id=5cf509cc&scoped=true", function () {
      api.rerender('5cf509cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryInfo/SelfDeliveryRiderList.vue"
export default component.exports